import React from 'react'
import injectSheet from 'react-jss'
import styles from './general.styles'
import Section from '../../../shared/section/section'
import Segment from '../../../shared/segment/segment'
import Segments from '../../../shared/segments/segments'
import Description from '../../../shared/description/description'
import Label from '../../../shared/label/label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Button from 'pobble-components/dist/button'
import classNames from 'classnames'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { validateDisplayName } from 'pobble-components/dist/validators'

const errorMsg = 'This field should not be empty'

const General = ({
  classes,
  pending,
  firstName,
  lastName,
  displayName,
  onSubmit
}) => (
  <Formik
    onSubmit={onSubmit}
    validationSchema={Yup.object().shape({
      firstName: Yup.string().required(errorMsg),
      lastName: Yup.string().required(errorMsg),
      displayName: validateDisplayName().required(errorMsg)
    })}
    initialValues={{
      firstName: firstName || '',
      lastName: lastName || '',
      displayName: displayName || ''
    }}>
    {formikProps => {
      const {
        values,
        handleBlur,
        handleChange,
        handleSubmit,
        isValid,
        errors
      } = formikProps
      return (
        <form
          onSubmit={handleSubmit}
          className={classNames(classes.form, { [classes.pending]: pending })}>
          <Section
            title="General"
            pending={pending}
            renderHeader={() => (
              <Button
                className={classes.submitButton}
                disabled={!isValid}
                type="submit"
                tall>
                Save changes
              </Button>
            )}>
            <Segments>
              <Segment>
                <Label htmlFor={'firstName'}>First name</Label>
                <FormInput
                  name="firstName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.firstName}
                  placeholder={'John'}
                  validationError={errors.firstName}
                />
              </Segment>
              <Segment>
                <Label htmlFor={'lastName'}>Last name</Label>
                <FormInput
                  name="lastName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.lastName}
                  placeholder={'Doe'}
                  validationError={errors.lastName}
                />
              </Segment>
              <Segment>
                <Description>
                  This is your real name. This is not displayed publicly on the
                  Pobble platform.
                </Description>
              </Segment>
            </Segments>
            <Segments>
              <Segment size={'M'}>
                <Label htmlFor={'displayName'}>Display name</Label>
                <FormInput
                  name="displayName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.displayName}
                  placeholder={'Ex: JohnDoe'}
                  validationError={errors.displayName}
                />
              </Segment>
              <Segment>
                <Description>
                  Your display name will be shown publicly, for example when you
                  leave a comment.
                </Description>
              </Segment>
            </Segments>
          </Section>
        </form>
      )
    }}
  </Formik>
)

export default injectSheet(styles)(General)
